/**
 * Removes the presentation-only trading card from the Shopify cart.
 * Fulfillment is handled by the backend; the storefront never keeps this as a line item.
 */
(function () {
  if (window.SundaySportsLegacyGiftCleanupInitialized) return;
  window.SundaySportsLegacyGiftCleanupInitialized = true;

  const giftProductId = 8842623811782;
  const routeRoot = window.Shopify?.routes?.root || "/";

  async function removeLegacyGiftLines() {
    try {
      const cart = await fetch(`${routeRoot}cart.js`, {
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      }).then((response) => response.json());

      const legacyGiftLines = (cart.items || []).filter(
        (item) => item.product_id === giftProductId
      );

      if (legacyGiftLines.length === 0) return;

      const updates = Object.fromEntries(
        legacyGiftLines.map((item) => [item.key, 0])
      );
      const sections = Array.from(
        document.querySelectorAll("cart-items-component[data-section-id]")
      )
        .map((component) => component.dataset.sectionId)
        .filter(Boolean);

      const response = await fetch(`${routeRoot}cart/update.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          updates,
          sections,
          sections_url: window.location.pathname,
        }),
      }).then((result) => result.json());

      const visibleItemCount = (response.items || []).reduce((count, item) => {
        if (item.product_id === giftProductId) return count;
        if (String(item.properties?._bundle_component).toLowerCase() === "true") return count;
        return count + item.quantity;
      }, 0);

      document.dispatchEvent(
        new CustomEvent("cart:update", {
          bubbles: true,
          detail: {
            resource: response,
            sourceId: "promo-gift-cleanup",
            data: {
              itemCount: visibleItemCount,
              sections: response.sections || {},
              source: "promo-gift-cleanup",
            },
          },
        })
      );
    } catch (error) {
      console.error("Legacy promo gift cleanup failed:", error);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", removeLegacyGiftLines, {
      once: true,
    });
  } else {
    removeLegacyGiftLines();
  }
})();
